import {Injectable} from "@angular/core";
import {
  IssueType,
  MessageIssueDto,
  MessageIssuePreviewDto, ResourceProfileDto,
  StereotypeUsageDto,
  SubmitMessageIssueDto
} from "@server-models";
import {FormGroup} from "@angular/forms";
import {SharedIssueStereotypeBaseService} from "@shared/components/issues/services/stereotype/shared-issue-stereotype-base.service";
import {TCurrentIssueDto} from "../types/issue-dto.type";
import {ILocalIssueDetailData} from "@shared/components/issues/interfaces/local-issue-detail-data.interface";
import {IAdditionalDetails} from "@shared/components/issues/interfaces/additional-details.interface";

@Injectable({
  providedIn: 'root',
})
export class SharedIssueMessageService extends SharedIssueStereotypeBaseService {

  override formatReadDetailData(issueDtoType: TCurrentIssueDto, issueType: IssueType): ILocalIssueDetailData {
    const issueDtoTypeMessage = issueDtoType as MessageIssueDto;
    return {
      ...this.formatBaseReadDetailData(issueDtoTypeMessage, issueType),
      additionalDetails: {...this.getAdditionalFormattedData(issueDtoTypeMessage)}
    };
  }

  prepareFormIssueDto(formGroup: FormGroup, templatePreviewDto: MessageIssuePreviewDto, resourceDto?: ResourceProfileDto): SubmitMessageIssueDto {
    const resourceFromGroup = formGroup.get('Resource');
    const issueStereotype: StereotypeUsageDto = templatePreviewDto.issueStereotype!;
    const customPropertyValues = this.getCustomPropertyValues(formGroup);
    const resource = resourceFromGroup?.value ? resourceFromGroup.value : resourceDto;

    return {
      title: templatePreviewDto.name,
      tenantId: issueStereotype?.tenantId,
      stereotypeId: issueStereotype?.stereotypeId,
      stereotypeRowVersion: issueStereotype?.rowVersion,
      customPropertyValues,
      resource: resource
    };
  }

  getAdditionalFormattedData(issueDto: MessageIssueDto): Partial<IAdditionalDetails> {
    return {};
  }

}
